export default __webpack_public_path__ + "static/media/mobile_balance-round.ad02a106.svg";